module.exports = __webpack_public_path__ + "img/typelist2.742953c9.svg";